/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Gender_MaleInputs */



/**
* | output |
* | --- |
* | "male" |
*
* @param {Voice_Manager_Gender_MaleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_gender_male = /** @type {((inputs?: Voice_Manager_Gender_MaleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Gender_MaleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("masculin")
	if (locale === "de") return /** @type {LocalizedString} */ ("männlich")
	if (locale === "it") return /** @type {LocalizedString} */ ("maschio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("мужской")
	if (locale === "es") return /** @type {LocalizedString} */ ("masculino")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("男性")
	if (locale === "ja") return /** @type {LocalizedString} */ ("男")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पुरुष")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("macho")
	return /** @type {LocalizedString} */ ("male")
});